import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import { icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import Notepad from "../components/notepad";
import SaveInfoTooltip from "../components/save_info_tooltip";
import SystemMessage from "../components/system_message";
import { useEffect, useRef, useState } from "react";
import NavBar from "../components/nav_bar";
import youSnapIcon from "../assets/images/you_snap.png";
import targetMarker from "../assets/images/you_snap/map_marker.png?url";
import addlMarker_1 from "../assets/images/you_snap/marker_1.svg?url";
import addlMarker_2 from "../assets/images/you_snap/marker_2.svg?url";
import addlMarker_3 from "../assets/images/you_snap/marker_3.svg?url";
import addlMarker_4 from "../assets/images/you_snap/marker_4.svg?url";
import addlMarker_5 from "../assets/images/you_snap/marker_5.svg?url";
import t from "../locales";

const targetLocation = t("yousnap_location");

const target = {
  location: targetLocation,
  icon: icon({
    iconUrl: targetMarker,
    iconSize: [40, 51],
    iconAnchor: [20, 51],
    popupAnchor: [0, -51],
  }),
};

const addlMarkers = [
  addlMarker_1,
  addlMarker_2,
  addlMarker_3,
  addlMarker_4,
  addlMarker_5,
].map((iconUrl) => {
  const location = [
    targetLocation[0] - Math.random() * (Math.random() < 0.5 ? -0.01 : 0.01),
    targetLocation[1] - Math.random() * (Math.random() < 0.5 ? -0.01 : 0.01),
  ];
  return {
    location,
    icon: icon({
      iconUrl,
      iconSize: [40, 51],
      iconAnchor: [20, 51],
      popupAnchor: [0, -51],
    }),
  };
});

export default function YouSnap() {
  const MIN_ZOOM_LEVEL = 13;
  const [zoomLevel, setZoomLevel] = useState(10);
  const wrapper = useRef();

  // We need a fixed value height on our wrapper, but don't know how much height we have left
  // So we determine it when the view is initialized
  // For now, we assume that the window won't get resized
  useEffect(() => {
    const { y } = wrapper.current.getBoundingClientRect();
    wrapper.current.style.setProperty(
      "height",
      `${window.screen.availHeight - y}px`,
    );
  }, [wrapper]);

  return (
    <>
      <SystemMessage text={t("yousnap_system_message")} specialZIndex={true} />
      <NavBar icon={youSnapIcon} />
      <div className="youSnap" ref={wrapper} style={{ height: "81vh" }}>
        <MapContainer
          center={target.location}
          zoom={zoomLevel}
          scrollWheelZoom={false}
          style={{ height: "100%" }}
        >
          <ZoomListener onZoom={(lvl) => setZoomLevel(lvl)} />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={target.location} icon={target.icon}>
            {zoomLevel > MIN_ZOOM_LEVEL && (
              <Popup className="tooltip__trigger">
                <SaveInfoTooltip name="chiro">
                  {t("secrets_chiro_value")}
                </SaveInfoTooltip>
              </Popup>
            )}
          </Marker>
          {addlMarkers.map((marker, index) => (
            <Marker position={marker.location} icon={marker.icon} key={index} />
          ))}
        </MapContainer>
        {/* We need to add a `z-index` that is just one above `.leaflet-pane` */}
        {zoomLevel > MIN_ZOOM_LEVEL && <Notepad style={{ zIndex: 401 }} />}
      </div>
    </>
  );
}

// NOTE: For some reason, we have to create a separate component for this listener
// We can't use `useMapEvents` in our `YouSnap` component.
function ZoomListener({ onZoom }) {
  useMapEvents({
    zoomend: (info) => onZoom(info.target._zoom),
  });
  return null;
}
